/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
/* eslint-disable */

const showMore = () => {
  const showMoreButton = document.querySelectorAll('.js-show-more-button');
  const showMoreContainers = document.querySelectorAll(
    '.js-show-more-container',
  );

  showMoreButton.forEach(item => {
    let showMoreContainer = item.querySelector('.js-show-more-container');
    const showMoreButtonText = item.querySelector('.js-show-more-button-text');
    let textStart;
    let textChange;
    let closeAll = true;

    if (showMoreContainer === null) {
      showMoreContainer = item.parentElement.querySelector(
        '.js-show-more-container',
      );
      closeAll = false;
    }

    if (
      typeof showMoreButtonText !== 'undefined' &&
      showMoreButtonText != null
    ) {
      textStart = item.dataset.textOpen;
      textChange = item.dataset.textClose;
    }

    item.addEventListener(
      'click',
      event => {
        const isLink = (event.target.tagName === 'A') || event.target.querySelector('a') ? true : false;
        const itemContainer = item.querySelector('.js-show-more-container');
        let isActive = false;
        if (itemContainer) {
          isActive = itemContainer.classList.contains('is-active');
        }
        if (closeAll && !isLink) {
          showMoreContainers.forEach(container => {
            if (container !== item) {
              container.classList.remove('is-active');
              container.parentElement
                .querySelector('.c-icon')
                .classList.remove('c-icon--rotate-180');
            }
          });
        }

        if (
          typeof showMoreButtonText !== 'undefined' &&
          showMoreButtonText != null
        ) {
          showMoreButtonText.textContent =
            showMoreButtonText.textContent === textStart
              ? textChange
              : textStart;
        }

        if (
          typeof showMoreContainer !== 'undefined' &&
          showMoreContainer != null &&
          !isActive
        ) {
          item.querySelector('.c-icon').classList.toggle('c-icon--rotate-180');
          showMoreContainer.classList.toggle('is-active');
        }
      },
      true,
    );
  });
};

export default showMore;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/showMore.js